import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';
import moment from 'moment';
import { LoadingAnimation } from '../../common/components/Utilities';
import UserSelect from '../../common/components/DataSelect/UserSelect';

function Timesheets() {
  const [start, setStart] = useState(moment().subtract(1, 'weeks').startOf('isoWeek'));
  const [end, setEnd] = useState(moment().subtract(1, 'weeks').endOf('isoWeek'));
  const [user, setUser] = useState();
  const [timeData, setTimeData] = useState({});
  const [loading, setLoading] = useState(false);

  const loadData = async () => {
    if (!user || !start || !end) {
      return;
    }

    setLoading(true);

    try {
      const response = await axios.get(`/timesheets/${user}/${start.format('Y-MM-DD')}/${end.format('Y-MM-DD')}`);
      setTimeData(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadData(); }, [user, start, end]);

  const updateStart = (event) => {
    setStart(moment(event.target.value));
  };

  const updateEnd = (event) => {
    setEnd(moment(event.target.value));
  };

  return (
    <div style={{ position: 'relative' }}>
      <LoadingAnimation loading={loading} />
      <Row className="mb-4">
        <Col md={4}>
          <UserSelect noneTitle="Select a user" onValueChange={setUser} />
        </Col>

        <Col md={4}>
          <Form.Control type="date" value={start.format('Y-MM-DD')} onChange={updateStart} />
        </Col>

        <Col md={4}>
          <Form.Control type="date" value={end.format('Y-MM-DD')} onChange={updateEnd} />
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <Timesheet {...timeData} />
        </Col>
      </Row>
    </div>
  );
}

export function UserTimesheet({ user, start, end }) {
  const [timeData, setTimeData] = useState(null);
  const [loading, setLoading] = useState(false);

  const loadData = async () => {
    setLoading(true);

    try {
      const response = await axios.get(`/timesheets/${user}/${start}/${end}`);
      setTimeData(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadData(); }, [user, start, end]);

  return (
    <div style={{ position: 'relative' }}>
      <LoadingAnimation loading={loading} />
      <Row>
        <Col md={12}>
          <Timesheet {...timeData} />
        </Col>
      </Row>
    </div>
  );
}

export function Timesheet({ days, data }) {
  if (!days) {
    return null;
  }

  return days.map((day) => (
    <TimesheetDay key={day} date={moment(day)} data={data[moment(day).format('YYYY-MM-DD')]} />
  ));
}

function TimesheetDay({ date, data }) {
  if (date.isoWeekday() > 5) {
    return null;
  }

  return (
    <Card className="mb-4">
      <Card.Header>{date.format('ddd, D MMMM YYYY')}</Card.Header>
      {(data !== null && data.length > 0) ? (
        <table className="table mb-0">
          <tbody>
            {data.map((project) => (
              <tr key={project.title}>
                <td>
                  <a href={`/project/${project.id}`}>{project.code}</a>
                  {' '}
                  -
                  {' '}
                  {project.title}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <Alert variant="warning m-2 mt-0">
          No time data was recorded for this day.
        </Alert>
      )}
    </Card>
  );
}

export default Timesheets;
